import { useEffect } from 'react'
import textServices from 'services/text-services'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'

interface ClosedSectionProps {
  id?: string
}

// Campaign closure card (Figma "Cierre dinámica", node 5606:4561): same dome
// and glass card as the success state, without the check icon and with the
// two-size headline of the closure frame.
const ClosedSection = ({ id }: ClosedSectionProps) => {
  useEffect(() => {
    dlTrackEvent('user_interaction', { action: 'view', element: 'la promocion ha terminado', section: 'neighbars' })
  }, [])

  return (
    <section id={id} className="neighbars__success neighbars__success--closed">
      <div className="neighbars__success-dome">
        <div className="neighbars__success-card">
          <h2 className="neighbars__success-title">
            <span className="neighbars__success-title-top">
              {textServices.findByText('neighbars/closed/titleTop', '¡La promoción')}
            </span>
            <span className="neighbars__success-title-main">
              {textServices.findByText('neighbars/closed/titleMain', 'ha terminado!')}
            </span>
          </h2>
          <p className="neighbars__success-text">
            {textServices.findByText(
              'neighbars/closed/text',
              'Si eres uno de los afortunados ganadores nos contactaremos contigo por correo. ¡Quédate atento!'
            )}
          </p>
        </div>
      </div>
    </section>
  )
}

export default ClosedSection
